import AntdCollapse from 'antd/lib/collapse';
import React        from 'react';

export type CollapseProps = React.ComponentProps<typeof AntdCollapse>;

export default function Collapse(props: CollapseProps) {
	return (
		<AntdCollapse {...props} />
	);
}
